<template lang="pug">
  div.client-data-section
    div.row-title.d-flex.pb-3
      b-icon-person-fill.mr-2.title
      h3.title Datos del Cliente
      b-icon.ml-2.edit-icon(
        v-if="ov.cliente"
        icon="pencil-square"
        role="button"
        title="Editar datos del cliente"
        @click="showEditModal = true"
      )
    //- Primera fila: RUT, Nombre/Razón Social, Apellido (solo para persona), Correo, Teléfono
    .data-grid(:class="{ 'empresa-grid': isEmpresa }")
      .data-item
        h4.data-label.rut R.U.T.
        h4.data-info {{ ovData.rut }}
      .data-item
        h4.data-label {{ isEmpresa ? 'Razón Social' : 'Nombre' }}
        h4.data-info {{ ovData.nombre }}
      .data-item(v-if="!isEmpresa")
        h4.data-label Apellido
        h4.data-info {{ ovData.apellido }}
      .data-item
        h4.data-label Correo Electrónico
        h4.data-info {{ ovData.correo_electronico }}
      .data-item
        h4.data-label Teléfono
        h4.data-info {{ ovData.telefono }}
    //- Segunda fila: Región, Comuna, Dirección
    .data-grid(:class="{ 'empresa-grid': isEmpresa }")
      .data-item
        h4.data-label Región
        h4.data-info {{ ovData.region }}
      .data-item
        h4.data-label Comuna
        h4.data-info {{ ovData.comuna }}
      .data-item
        h4.data-label Dirección
        h4.data-info {{ ovData.direccion }}
    //- Comentario separado (ocupa más espacio)
    .comentario-section(v-if="ovData.comentario !== '-'")
      h4.data-label Comentario
      h4.data-info {{ ovData.comentario }}
    EditClienteOVModal(
      v-if="ov.cliente"
      v-model="showEditModal"
      :ov="ov"
      @saved="$emit('saved')"
    )
</template>

<script>
import EditClienteOVModal from './EditClienteOVModal.vue'

export default {
  name: 'OVDetailClienteData',
  components: { EditClienteOVModal },
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showEditModal: false,
    }
  },
  computed: {
    isEmpresa() {
      return this.ov.datos_cliente.cliente_tipo === 'empresa'
    },
    ovData() {
      return {
        rut: this.ov.rut || '-',
        nombre: this.ov.nombre || '-',
        apellido: this.ov.apellido || '-',
        correo_electronico: this.ov.correo_electronico || '-',
        telefono: this.ov.telefono || '-',
        region: this.ov.region || '-',
        comuna: this.ov.comuna || '-',
        direccion: this.ov.direccion || '-',
        comentario: this.ov.comentario || '-',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

.row-title {
  align-items: center;
}

.data-label {
  font-size: 15px;
  font-weight: 700;
  text-align: left;
  color: #525252;
  margin: 0;
}

.rut {
  color: var(--blue-accent);
}

.data-info {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
  text-align: left;
}

.client-data-section {
  display: flex;
  flex-direction: column;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  padding: 0.5rem 0;

  &.empresa-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    grid-template-columns: repeat(2, 1fr);

    &.empresa-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
}

.data-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.comentario-section {
  padding: 0.5rem 0;
  margin-top: 0.5rem;
}

.edit-icon {
  font-size: 18px;
  color: var(--blue-accent);
  cursor: pointer;
  align-self: center;
  &:hover {
    opacity: 0.7;
  }
}
</style>
